const iconTooltip = {
    info: 'info',
    edit: 'edit',
    remove: 'remove',
    download: 'download',
    upload: 'upload',
    copy: 'copy',
    comments: 'comments',
    complianceGuidance: 'compliance guidance',
    changeLog: 'change log',
    actionLog: 'action log',
    copyReportSource: 'export config',
    source: 'source',
    viewReleased: 'view released',
    viewChanges: 'view changes',
    configInfo: 'Config info',
    downloadReportConfigSummary: 'Download Report config summary',
    view: 'View only',
    fourEyesReleaseSwitch: 'This is a control mechanism which enables admin users to review and approve/reject release changes made by another admin users.',
    search: 'Search',
    clear: 'Clear',
    refresh: 'Refresh',
    changeDataSourceFromToIcon:"Change config's datasource from one to another"
};

export default iconTooltip;
